import React, { Fragment, Component } from "react";
import Breadcrumb from "../components/common/breadcrumb";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./Dashboard.css";
import Time from "react-time-format";
import { Tabs, TabList, Tab } from "react-tabs";
// import actions
import { change_Lang } from "../actions/Helper_action";
import {
  Count_Avilable_Property,
  Count_Rent_Contract,
  Count_Required_Property,
  Count_Sell_Contract,
  Get_Rent_Chart_Vertical,
  Get_Sell_Rent_Chart_Vertical,
  Newest_Rent_Contract,
  Newest_Sell_Contract,
} from "../actions/Dashboard_action";
import { isMobile } from "react-device-detect";
import { All_List_Sell_Property } from "../actions/Project_action";
import { Get_List_All_Rent_Contracts } from "../actions/Invoice_action";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import NumberFormat from "react-number-format";
import _ from "lodash";
import {
  FaCommentsDollar,
  FaHandSparkles,
  FaHome,
  FaHouseUser,
  FaPaste,
  FaUsers,
} from "react-icons/fa";
class Redashboard extends Component {
  componentDidMount() {
    const {
      Count_Sell_Contract,
      Count_Rent_Contract,
      Count_Avilable_Property,
      Newest_Sell_Contract,
      Newest_Rent_Contract,
      Get_Sell_Rent_Chart_Vertical,
      Get_Rent_Chart_Vertical,
      Count_Required_Property,
    } = this.props;
    Count_Sell_Contract();
    Count_Rent_Contract();
    Count_Avilable_Property();
    Newest_Sell_Contract();
    Newest_Rent_Contract();
    Get_Sell_Rent_Chart_Vertical();
    Get_Rent_Chart_Vertical();
    Count_Required_Property();
  }

  render() {
    const {
      change_Lang,
      lang,
      count_total_Scontract,
      count_total_Rcontract,
      count_avilable_property,
      newest_sell_contracts,
      newest_rent_contracts,
      required_count,
      sell_Vertital_chart_contract,
      rent_Vertital_chart_contract,
    } = this.props;
    const Get_Total_Sale_Persentage = () => {
      let count_sold = count_total_Scontract;
      let count_rent = count_total_Rcontract;
      let all = _.add(count_sold, count_rent);
      let devide_sold = _.divide(count_sold, all);
      const Sold_Persentage = _.multiply(devide_sold, 100);
      return Math.floor(Sold_Persentage);
    };
    const Get_Total_Rent_Persentage = () => {
      let count_sold = count_total_Scontract;
      let count_rent = count_total_Rcontract;
      let all = _.add(count_sold, count_rent);
      let devide_rent = _.divide(count_rent, all);
      const Hold_persentage = _.multiply(devide_rent, 100);
      return Math.floor(Hold_persentage);
    };
    return (
      <>
        <Fragment>
          <Breadcrumb
            title={change_Lang("s_dashboard")}
            parent={change_Lang("s_dashboard")}
          />
          <div
            className={`${
              lang === "en" ? "container-fluid" : "container-fluid fk"
            }`}
          >
            <div className="row">
              <div className="col-xl-3 col-md-6 xl-50 mb-3">
                <div className="card o-hidden widget-cards cardss">
                  {isMobile !== true ? (
                    <div className=" card-body">
                      <Link to="/list_all_sell_contracts">
                        {" "}
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className="btn py-2 px-3  btn-sm"
                              style={{
                                color: "#4064d7",
                                background: "#efefed",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-solid fa-handshake"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8 text-center">
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {change_Lang("Sell_Contracts")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {count_total_Scontract}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : (
                    <div
                      className=" card-body"
                      style={{ background: "#f6f8fa" }}
                    >
                      <Link to="/list_all_sell_contracts">
                        {" "}
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className={
                                lang === "en"
                                  ? "btn py-3 ml-4  btn-sm"
                                  : "btn py-3 mr-4  btn-sm"
                              }
                              style={{
                                color: "#efefed",
                                background: "#4064d7",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-regular fa-paste"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8">
                            <span
                              className="m-0 d-flex justify-content-center"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Sell_Contracts")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {count_total_Scontract}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
              {isMobile !== true ? (
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <Link
                    to="/list_all_rent_contracts"
                    onClick={() => Get_List_All_Rent_Contracts()}
                  >
                    <div className="card o-hidden widget-cards cardss">
                      <div className=" card-body">
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className="btn py-2 px-3  btn-sm"
                              style={{
                                color: "#4064d7",
                                background: "#efefed",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-regular fa-paste"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8 text-center">
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {change_Lang("Rental contract")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {count_total_Rcontract}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : (
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <Link
                    to="/list_all_rent_contracts"
                    onClick={() => Get_List_All_Rent_Contracts()}
                  >
                    <div className="card o-hidden widget-cards cardss">
                      <div
                        className=" card-body"
                        style={{ background: "#f6f8fa" }}
                      >
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className={
                                lang === "en"
                                  ? "btn py-3 ml-4  btn-sm"
                                  : "btn py-3 mr-4  btn-sm"
                              }
                              style={{
                                color: "#efefed",
                                background: "#4064d7",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-regular fa-paste"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8">
                            <span
                              className="m-0 d-flex justify-content-center"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Rental contract")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {count_total_Rcontract}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
              {isMobile !== true ? (
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <Link
                    to="/All_Sell_Property"
                    onClick={() => this.props.All_List_Sell_Property()}
                  >
                    <div className="card o-hidden widget-cards cardss">
                      <div className=" card-body">
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className="btn py-2 px-3  btn-sm"
                              style={{
                                color: "#4064d7",
                                background: "#efefed",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-solid fa-house-user"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8 text-center">
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {change_Lang("Number of properties")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {count_avilable_property}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : (
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <Link
                    to="/All_Sell_Property"
                    onClick={() => this.props.All_List_Sell_Property()}
                  >
                    <div className="card o-hidden widget-cards cardss">
                      <div
                        className=" card-body"
                        style={{ background: "#f6f8fa" }}
                      >
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className={
                                lang === "en"
                                  ? "btn py-3 ml-4  btn-sm"
                                  : "btn py-3 mr-4  btn-sm"
                              }
                              style={{
                                color: "#efefed",
                                background: "#4064d7",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-solid fa-house-user"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8">
                            <span
                              className="m-0 d-flex justify-content-center"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Number of properties")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {count_avilable_property}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
              {isMobile !== true ? (
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <Link to="/All_Required_Sell">
                    <div className="card o-hidden widget-cards cardss">
                      <div className=" card-body">
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className="btn py-2 px-3  btn-sm"
                              style={{
                                color: "#4064d7",
                                background: "#efefed",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-solid fa-hand-sparkles"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8 text-center">
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {change_Lang("Required Property List")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {required_count}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : (
                <div className="col-xl-3 col-md-6 xl-50 mb-3">
                  <Link to="/All_Required_Sell">
                    <div className="card o-hidden widget-cards cardss">
                      <div
                        className=" card-body"
                        style={{ background: "#f6f8fa" }}
                      >
                        <div className="media static-top-widget row">
                          <div className="align-self-center text-center">
                            <button
                              className={
                                lang === "en"
                                  ? "btn py-3 ml-4  btn-sm"
                                  : "btn py-3 mr-4  btn-sm"
                              }
                              style={{
                                color: "#efefed",
                                background: "#4064d7",
                                borderRadius: "10px",
                              }}
                            >
                              <i
                                className="fa-solid fa-hand-sparkles"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                          <div className="media-body col-8">
                            <span
                              className="m-0 d-flex justify-content-center"
                              style={{ fontSize: "16px", color: "black" }}
                            >
                              {change_Lang("Required Property List")}
                            </span>
                            <br />
                            <span
                              className="m-0 fk"
                              style={{ fontSize: "14px", color: "gray" }}
                            >
                              {required_count}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
            {/* soft */}
            <Tabs>
              <TabList
                style={{
                  background: "#fff",
                  borderRadius: "10px",
                  color: "#4064d7",
                }}
                className={`${
                  lang === "en"
                    ? "nav nav-tabs tab-coupon d-flex justify-content-center"
                    : "nav nav-tabs tab-coupon d-flex justify-content-center  fk"
                }`}
              >
                <Tab className="nav-item nav-tabs tab-coupon">
                  <Link
                    to="/All_Rent_Property"
                    className="nav-link"
                    aria-selected="true"
                    style={{ color: "#4064d7", fontWeight: "bold" }}
                  >
                    <FaHouseUser />
                    &nbsp;
                    {change_Lang("Rent List")}(عرض)
                  </Link>
                </Tab>
                <Tab className="nav-item nav-tabs tab-coupon">
                  <Link
                    to="/All_Sell_Property"
                    className="nav-link"
                    aria-selected="true"
                    style={{ color: "#4064d7", fontWeight: "bold" }}
                  >
                    <FaHome />
                    &nbsp;
                    {change_Lang("Sell List")}(عرض)
                  </Link>
                </Tab>
                <Tab className="nav-item">
                  <Link
                    className="nav-link"
                    to="/list_all_sell_contracts"
                    style={{ color: "#4064d7", fontWeight: "bold" }}
                  >
                    <FaPaste />
                    &nbsp;
                    {change_Lang("Contract List")}
                  </Link>
                </Tab>
                <Tab className="nav-item">
                  <Link
                    className="nav-link"
                    to="/All_Required_Sell"
                    style={{ color: "#4064d7", fontWeight: "bold" }}
                  >
                    <FaHandSparkles />
                    &nbsp;
                    {change_Lang("ListReuiredProperty")} (طلبية)
                  </Link>
                </Tab>
                <Tab className="nav-item">
                  <Link
                    className="nav-link"
                    to="/list_BranchMasrufat"
                    style={{ color: "#4064d7", fontWeight: "bold" }}
                  >
                    <FaCommentsDollar />
                    &nbsp;
                    {change_Lang("Expenses")}
                  </Link>
                </Tab>
                <Tab className="nav-item">
                  <Link
                    className="nav-link"
                    to="/List_Tenants"
                    style={{ color: "#4064d7", fontWeight: "bold" }}
                  >
                    <FaUsers />
                    &nbsp;
                    {change_Lang("List of Tenants")}
                  </Link>
                </Tab>
              </TabList>
            </Tabs>
            <div className="row">
              <div className="col-xl-6 xl-100">
                <div className="card">
                  <div className="card-header">
                    <h5 className="text-center">
                      {change_Lang("newest sell contract")}
                    </h5>
                  </div>
                  <div className="card-body" style={{ background: "#f9fafc" }}>
                    <div className="user-status table-responsive latest-order-table">
                      <table className="table table-bordernone">
                        <thead>
                          <tr>
                            <th
                              style={{ color: "gray", fontSize: "12px" }}
                              scope="col"
                            >
                              {change_Lang("id")}
                            </th>
                            <th
                              style={{ color: "gray", fontSize: "12px" }}
                              scope="col"
                            >
                              {change_Lang("Seller")}
                            </th>
                            <th
                              style={{ color: "gray", fontSize: "12px" }}
                              scope="col"
                            >
                              {change_Lang("Buyer")}
                            </th>
                            <th
                              style={{ color: "gray", fontSize: "12px" }}
                              scope="col"
                            >
                              {change_Lang("Total money.")}
                            </th>
                            <th
                              style={{
                                color: "gray",
                                fontSize: "12px",
                                width: "130px",
                              }}
                              scope="col"
                            >
                              {change_Lang("date")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {newest_sell_contracts.map((el, i) => {
                            return (
                              <tr
                                key={i}
                                style={{ fontWeight: "bold", color: "#495681" }}
                              >
                                <td className="digits">{el.InvoiceNO}</td>
                                <td className="digits">{el.firstname}</td>
                                <td className="digits">{el.secondname}</td>

                                <td className="">
                                  {" "}
                                  <NumberFormat
                                    displayType="text"
                                    thousandSeparator={true}
                                    value={el.lastPrice}
                                    prefix="$"
                                  />
                                </td>
                                <td className="digits fk">
                                  <Time
                                    value={el.createdAt}
                                    format="YYYY-MM-DD"
                                    style={{ color: "#495681" }}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <br />
                      <Link
                        to="/list_all_sell_contracts"
                        className="btn btn col-12 text-primary"
                        style={{ background: "white" }}
                      >
                        {change_Lang("d_viewall")}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 xl-100">
                <div className="card">
                  <div className="card-header">
                    <h5 className="text-center">
                      {change_Lang("The latest sales Chart")}
                    </h5>
                  </div>
                  <div className="card-body" style={{ background: "#fff" }}>
                    <div style={{ width: "100%", height: 350 }}>
                      <ResponsiveContainer>
                        <AreaChart
                          data={sell_Vertital_chart_contract}
                          margin={{
                            top: 10,
                            right: 30,
                            left: 0,
                            bottom: 0,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey={"month"} />
                          <YAxis />
                          <Tooltip />
                          <Area
                            type="monotone"
                            dataKey="sell"
                            stroke="#4064d7"
                            fill="#eceffb"
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Line Chart */}
            <div className="row">
              <div className="col-xl-12 xl-100">
                <div className="card">
                  <div className="card-header">
                    <h5 className="text-center">{change_Lang("Contract")}</h5>
                  </div>
                  <div className="card-body" style={{ background: "#fff" }}>
                    <div
                      style={{
                        width: "100%",
                        height: 30,
                        background: `linear-gradient(${
                          lang === "en" ? "to right" : "to right"
                        }, ${
                          count_total_Rcontract > count_total_Scontract
                            ? "#ffcd41"
                            : "#7242e2"
                        } ${
                          count_total_Rcontract > count_total_Scontract
                            ? Get_Total_Rent_Persentage()
                            : Get_Total_Sale_Persentage()
                        }%, ${
                          count_total_Rcontract > count_total_Scontract
                            ? "#7242e2"
                            : "#ffcd41"
                        } ${
                          count_total_Rcontract > count_total_Scontract
                            ? Get_Total_Sale_Persentage()
                            : Get_Total_Rent_Persentage()
                        }%)`,
                        borderRadius: "25px",
                        justifyContent: "space-between ",
                      }}
                    >
                      {lang !== "en" ? (
                        <div
                          style={{
                            justifyContent: "space-between",
                            display: "flex",
                          }}
                        >
                          <span
                            style={{
                              color: "white",
                              padding: "5px",
                              textAlign: "center",
                              marginLeft: "10px",
                            }}
                          >
                            {count_total_Scontract}
                          </span>
                          <span
                            style={{
                              color: "white",
                              padding: "5px",
                              textAlign: "center",
                              marginRight: "10px",
                            }}
                          >
                            {count_total_Rcontract}
                          </span>
                        </div>
                      ) : (
                        <div
                          style={{
                            justifyContent: "space-between",
                            display: "flex",
                          }}
                        >
                          <span
                            style={{
                              color: "white",
                              padding: "5px",
                              textAlign: "center",
                              marginLeft: "10px",
                            }}
                          >
                            {count_total_Rcontract}
                          </span>
                          <span
                            style={{
                              color: "white",
                              padding: "5px",
                              textAlign: "center",
                              marginRight: "10px",
                            }}
                          >
                            {count_total_Scontract}
                          </span>
                        </div>
                      )}
                    </div>
                    {lang !== "en" ? (
                      <div className="row">
                        <div className="col-xl-6 xl-100 text-center mt-4">
                          {change_Lang("Sell")}
                          <hr
                            style={{
                              height: "10px",
                              width: "50px",
                              background: "#7242e2",
                              borderRadius: "20px",
                            }}
                          />
                        </div>
                        <div className="col-xl-6 xl-100 text-center mt-4">
                          {change_Lang("Rent")}
                          <hr
                            style={{
                              height: "10px",
                              width: "50px",
                              background: "#ffcd41",
                              borderRadius: "20px",
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-xl-6 xl-100 text-center mt-4">
                          {change_Lang("Rent")}
                          <hr
                            style={{
                              height: "10px",
                              width: "50px",
                              background: "#ffcd41",
                              borderRadius: "20px",
                            }}
                          />
                        </div>
                        <div className="col-xl-6 xl-100 text-center mt-4">
                          {change_Lang("Sell")}
                          <hr
                            style={{
                              height: "10px",
                              width: "50px",
                              background: "#7242e2",
                              borderRadius: "20px",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Hold Report */}
            <div className="row">
              <div className="col-xl-6 xl-100">
                <div className="card">
                  <div className="card-header">
                    <h5 className="text-center">
                      {change_Lang("newest rent contract")}
                    </h5>
                  </div>
                  <div className="card-body" style={{ background: "#f9fafc" }}>
                    <div className="user-status table-responsive latest-order-table">
                      <table className="table table-bordernone">
                        <thead>
                          <tr>
                            <th
                              style={{ color: "gray", fontSize: "12px" }}
                              scope="col"
                            >
                              {change_Lang("id")}
                            </th>
                            <th
                              style={{ color: "gray", fontSize: "12px" }}
                              scope="col"
                            >
                              {change_Lang("property owner")}
                            </th>
                            <th
                              style={{ color: "gray", fontSize: "12px" }}
                              scope="col"
                            >
                              {change_Lang("tenant")}
                            </th>
                            <th
                              style={{
                                color: "gray",
                                fontSize: "12px",
                                width: "80px",
                              }}
                              scope="col"
                            >
                              {change_Lang("Total money.")}
                            </th>
                            <th
                              style={{
                                color: "gray",
                                fontSize: "12px",
                                width: "120px",
                              }}
                              scope="col"
                            >
                              {change_Lang("date")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {newest_rent_contracts.map((el, i) => {
                            return (
                              <tr
                                key={i}
                                style={{ fontWeight: "bold", color: "#495681" }}
                              >
                                <td className="digits">{el.InvoiceNO}</td>
                                <td className="digits">{el.firstname}</td>
                                <td className="digits">
                                  {el.tenantId && el.tenantId.secondname}
                                </td>

                                <td className="">
                                  {" "}
                                  <NumberFormat
                                    displayType="text"
                                    thousandSeparator={true}
                                    value={el.paymentmonth}
                                    prefix={
                                      el.currency !== "dolar" ? "IQD" : "$"
                                    }
                                  />
                                </td>
                                <td className="digits fk">
                                  <Time
                                    value={el.createdAt}
                                    format="YYYY-MM-DD"
                                    style={{ color: "#495681" }}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <br />
                      <Link
                        to="/list_all_rent_contracts"
                        className="btn btn col-12 text-primary"
                        style={{ background: "white" }}
                      >
                        {change_Lang("d_viewall")}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 xl-100">
                <div className="card">
                  <div className="card-header">
                    <h5 className="text-center">
                      {change_Lang("The latest hold Chart")}
                    </h5>
                  </div>
                  <div className="card-body" style={{ background: "#fff" }}>
                    <div style={{ width: "100%", height: 350 }}>
                      <ResponsiveContainer>
                        <AreaChart
                          data={rent_Vertital_chart_contract}
                          margin={{
                            top: 10,
                            right: 30,
                            left: 0,
                            bottom: 0,
                          }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="month" />
                          <YAxis />
                          <Tooltip />
                          <Area
                            type="monotone"
                            dataKey="rent"
                            stroke="#ffcd41"
                            fill="#fce282"
                          />
                        </AreaChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </>
    );
  }
}

const MapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    count_total_Rcontract: state.DashboardReducer.count_total_Rcontract,
    count_total_Scontract: state.DashboardReducer.count_total_Scontract,
    count_avilable_property: state.DashboardReducer.count_avilable_property,
    count_total_money: state.DashboardReducer.count_total_money,
    newest_sell_contracts: state.DashboardReducer.newest_sell_contracts,
    newest_rent_contracts: state.DashboardReducer.newest_rent_contracts,
    required_count: state.DashboardReducer.required_count,
    sell_Vertital_chart_contract:
      state.DashboardReducer.sell_Vertital_chart_contract,
    rent_Vertital_chart_contract:
      state.DashboardReducer.rent_Vertital_chart_contract,
  };
};

const MapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Count_Rent_Contract: () => dispatch(Count_Rent_Contract()),
    Count_Sell_Contract: () => dispatch(Count_Sell_Contract()),
    Count_Avilable_Property: () => dispatch(Count_Avilable_Property()),
    All_List_Sell_Property: () => dispatch(All_List_Sell_Property()),
    Get_List_All_Rent_Contracts: () => dispatch(Get_List_All_Rent_Contracts()),
    Newest_Sell_Contract: () => dispatch(Newest_Sell_Contract()),
    Newest_Rent_Contract: () => dispatch(Newest_Rent_Contract()),
    Get_Sell_Rent_Chart_Vertical: () =>
      dispatch(Get_Sell_Rent_Chart_Vertical()),
    Get_Rent_Chart_Vertical: () => dispatch(Get_Rent_Chart_Vertical()),
    Count_Required_Property: () => dispatch(Count_Required_Property()),
  };
};
export default connect(MapStateToProps, MapDispatchToProps)(Redashboard);
